<template>
  <div class="full-view"
       :style="'background-image: url(\'' + settings.staticImageUrl + '/friends.jpg\')'"
  >
    <mdb-mask class="gradient d-flex justify-content-center align-items-center overflow-auto">
      <div class="input-form">
        <mdb-card>
          <mdb-card-header class="primary-color text-white">
            <h3>Welcome</h3>
          </mdb-card-header>
          <mdb-card-body>
            <h4>Please enter the code you were provided.</h4>
            <mdb-input id="link-code" type="text"
                       v-model="linkCode" placeholder="Code" @keydown.native="handleKeydown"/>
            <mdb-btn :disabled="!linkCode" @click="findLink" icon="check">Go</mdb-btn>
          </mdb-card-body>
        </mdb-card>
      </div>
    </mdb-mask>

  </div>
</template>
<script>
import api from '../services/groupsPlaceApi.js'
import {mdbCard, mdbCardHeader, mdbCardBody, mdbInput, mdbBtn, mdbMask} from 'mdbvue';

export default {
  name: "quick-link",
  components: {
    mdbCard, mdbCardHeader, mdbCardBody, mdbInput, mdbBtn, mdbMask
  },
  computed: {
    settings() {
      return this.$store.state.settings
    },
  },
  data() {
    return {
      linkCode: ""
    }
  },
  mounted() {
    let el = document.getElementById("link-code")
    if (el) el.focus()
  },
  methods: {
    handleKeydown(e) {
      if (e.keyCode == 13 && this.linkCode) this.findLink()
    },
    findLink() {
      this.$store.dispatch("setExecuting", true)
      let lastToken = localStorage.getItem("lastPresentationToken")
      let url = "/public/quickLink/"
      api.post(url, {linkCode: this.linkCode}).then(
        (results) => {
          this.$router.push(results.data.destination)
        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }
};

</script>
<style scoped>
@media screen and (max-width: 749px ) {
  .input-form {
    margin: auto;
    width: 80%;

  }
}

@media screen and (min-width: 750px ) {
  .input-form {
    margin: auto;
    width: 50%;
  }
}

.gradient {
  background: -moz-linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
  background: -webkit-linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
  background: -webkit-gradient(linear, 45deg, from(rgba(42, 27, 161, 0.7)), to(rgba(29, 210, 177, 0.7)));
  background: -o-linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
  background: linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
  height: calc(100vh);
}

.full-view {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  height: calc(100vh);
}



</style>
